import { render, staticRenderFns } from "./Manufacturer.vue?vue&type=template&id=2ba66190&scoped=true&"
import script from "./Manufacturer.vue?vue&type=script&lang=js&"
export * from "./Manufacturer.vue?vue&type=script&lang=js&"
import style0 from "./Manufacturer.vue?vue&type=style&index=0&id=2ba66190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba66190",
  null
  
)

export default component.exports